module.exports = __webpack_public_path__ + "static/img/luo.20a3626.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/luo.png
// module id = 569
// module chunks = 143